import config from "../../../config"
export default (callback) => {
  if (window.AMap) {
    callback && callback();
    return;
  }
  var url = config.AMAP_URL;
  var jsapi = document.createElement("script");
  jsapi.src = url;
  jsapi.onload = () => {
    setTimeout(() => {
      callback && callback();
    }, 0);
  };
  document.head.appendChild(jsapi);
};
